module.exports = __webpack_public_path__ + "img/elice_6.673bcd43.svg";